const getColorByName = (
  colorName: string
): { bgColor: string; bColor: string } => {
  switch (colorName) {
    case 'white':
      return { bgColor: 'white', bColor: '#b9b9b9' };
    case 'yellow':
      return { bgColor: '#feff12', bColor: '#d7d80e' };
    case 'orange':
      return { bgColor: '#fe7e07', bColor: '#b85e0a' };
    case 'purple':
      return { bgColor: '#fe14ff', bColor: '#bc0dbd' };
    case 'violet':
      return { bgColor: '#8b0aff', bColor: '#740dcf' };
    case 'blue':
      return { bgColor: '#140fff', bColor: '#0503bd' };
    case 'aquamarine':
      return { bgColor: '#0cfcff', bColor: '#09c4c7' };
    case 'green':
      return { bgColor: '#aafcc1', bColor: '#8fd3a3' };
    default:
      return { bgColor: '', bColor: '' };
  }
};

export default getColorByName;
